import {
  Paper,
  TableContainer,
  TableContainerProps,
  TableHead,
  TableHeadProps,
  makeStyles,
} from '@material-ui/core';
import { Alert } from '@material-ui/lab';

import { LoadingOverlayMui as LoadingOverlay } from './LoadingOverlay';

const useTableContainerStyles = makeStyles({
  wrapper: {
    position: 'relative',
  },
  tableContainer: {
    display: 'initial',
    width: '100%',
    overflowX: 'auto',
    border: 'none',
    '& th': {
      fontWeight: 'bold',
    },
    '& > table': {
      width: '100%',
      borderCollapse: 'unset',
    },
  },
});

const useTableHeadStyles = makeStyles(
  theme => ({
    tableHeader: ({ topOffset }: { topOffset: number }) => ({
      position: 'sticky',
      top: topOffset,
      zIndex: 1,
      background: theme.palette.background.default,
    }),
  }),
  { name: 'StickyTableContainer' },
);

export const StickyTableContainerMui = ({
  children,
  loading = false,
  error,
}: TableContainerProps & { loading?: boolean; error?: Error | null }) => {
  const classes = useTableContainerStyles();

  return (
    <Paper className={classes.wrapper} variant="elevation" elevation={0}>
      <LoadingOverlay loading={loading} />
      {error && <Alert severity="error">{error.message}</Alert>}
      <TableContainer component={Paper} className={classes.tableContainer}>
        {children}
      </TableContainer>
    </Paper>
  );
};

export const StickyTableHeadMui = ({
  children,
  topOffset = 0,
}: TableHeadProps & { topOffset?: number }) => {
  const classes = useTableHeadStyles({ topOffset });
  return (
    <TableHead
      data-component="StickyTableHeader"
      className={classes.tableHeader}
    >
      {children}
    </TableHead>
  );
};
